<template>
  <div id="profile" class="container">
    <section>
      <div class="section-group">
        <div class="row">
          <div class="col-md-3">
            <div class="card">
              <div class="card-body box-profile">
                <div class="text-center">
                  <!-- <el-avatar
                    :src="customer.userLogoBig"
                    :size="100"
                  ></el-avatar> -->
                  <avatarVue :src="`${customer.userLogoBig}?v=${getN()}`" :size="100"></avatarVue>
                </div>
                <h3 class="profile-username text-center mb-1">
                  {{ customer.displayName }}
                </h3>
                  <div class="reward_center mt-2 mb-2">
                        <!-- 獎牌名單列表 -->
        				<div class="toooltip" v-for="(item, idx) in medalListData">
        					<img :src="item.sgL_URL" style="width:40px;">
        					<span class="toooltiptext">{{ item.sgL_Title }}<br/> 
        						<span class="exchange_point b-operate-btn" type="button" @click="showExchangePoint(item.id)">兌換為點數</span>
        					</span>
        				</div>
        			  </div>
                <p class="text-center mb-1">現有點數：{{ Runningwater.sgL_AfterPoint ? Runningwater.sgL_AfterPoint : 0 }}</p>
                <p class="text-muted text-center">{{ customer.sgL_Myself }}</p>
              </div>
              <!-- /.card-body -->
              <div class="card-body">
                <ul>
                  <li class="profile-nav" v-if="customers">
                    <router-link :to="{ name: 'customerPublishLook', query: { 'authorId': customers.userId } }">
                      <i class="fas fa-user-circle fa-fw mr-1" /> {{ $t('Customer.customerPublish.Homepage') }}
                    </router-link>
                  </li>
                  <li class="profile-nav">
                    <router-link :to="{ name: 'customerPublish' }">
                      <i class="fas fa-share fa-fw mr-1"></i> {{ $t('Customer.customerInfo.customerPublish') }}
                    </router-link>
                  </li>
                  <li class="profile-nav">
                    <router-link :to="{ name: 'customerFavorite' }"><i class="fas fa-bookmark fa-fw mr-1"></i> {{
                      $t('Customer.customerInfo.customerFavorite') }}
                    </router-link>
                  </li>
                  <li class="profile-nav">
                    <router-link :to="{ name: 'customerPrivateMessage' }"><i class="fas fa-comments fa-fw mr-1"></i> {{
                      $t('Customer.customerInfo.customerPrivateMessage') }}
                    </router-link>
                  </li>
                  <!-- <li class="profile-nav">
                    <router-link :to="{ name: 'customerMessage' }"
                      ><i class="fas fa-comments fa-fw mr-1"></i> 我的留言
                    </router-link>
                  </li> -->
                  <li class="profile-nav active">
                    <router-link :to="{ name: 'customerInfo' }"><i class="fas fa-cog fa-fw mr-1"></i> {{
                      $t('Customer.customerInfo.customerInfo') }}
                    </router-link>
                  </li>
                </ul>
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>
          <!-- /.col -->
          <div class="col-md-9 pl-md-4">
            <div class="card">
              <div class="card-header">
                <div class="row">
                  <div class="col-12">
                    <ul class="nav nav-pills">
                      <li class="nav-item">
                        <a class="nav-link" :class="{ active: showType === 1 }" @click="change(1)"
                          href="javascript:void(0)" data-toggle="tab"> {{ $t('Customer.customerInfo.setting') }}</a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" :class="{ active: showType === 2 }" @click="change(2)"
                          href="javascript:void(0)" data-toggle="tab"> {{ $t('Customer.customerInfo.Changepassword')
                          }}</a>
                      </li>
                      <!-- <li class="nav-item">
                        <a
                          class="nav-link"
                          :class="{ active: showType == 3 }"
                          @click="change(3)"
                          href="javascript:void(0)"
                          data-toggle="tab"
                          >我的留言</a
                        >
                      </li> -->
                    </ul>
                  </div>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body">
                <!-- My Profile -->
                <div class="my-profile section-group">
                  <div v-if="customerModel != null">
                    <div class="row" v-show="showType === 1">
                      <div class="col-12">
                        <el-form :model="customerModel" :rules="customerModelrule" ref="customerModel"
                          label-width="100px">
                          <el-form-item :label="$t('Customer.customerInfo.profilepicture')">
                            <el-upload class="avatar-uploader" :auto-upload="false" action="" :show-file-list="false"
                              :on-change="changeUpload" ref="avatarUploader">
                              <avatarVue :src="`${customer.userLogoBig}?v=${getN()}`" :size="100"></avatarVue>
                            </el-upload>
                            <ImgCropperVue ref="cro" @cropperConfirm="cropperConfirm" :props_autoCropWidth="380"
                              :props_autoCropHeight="380" :props_full="false" :props_original="true"
                              :props_centerBox="true" :props_high="false" :props_fixed="true" :props_info="true"
                              :props_canMove="true" :props_canScale="true">
                            </ImgCropperVue>
                          </el-form-item>
                          <el-form-item :label="$t('Customer.customerInfo.Membername')" prop="sgL_UsersName">
                            <el-input :placeholder="$t('Customer.customerInfo.UsersName')"
                              v-model="customerModel.sgL_UsersName"></el-input>
                          </el-form-item>
                          <el-form-item :label="$t('Customer.customerInfo.MyVideoName')" prop="sgL_MyVideoName">
                            <el-input :placeholder="$t('Customer.customerInfo.customerMyVideoName')"
                              v-model="customerModel.sgL_MyVideoName"></el-input>
                          </el-form-item>

                          <el-form-item :label="$t('Customer.customerInfo.selfintroduction')">
                            <el-input :placeholder="$t('Customer.customerInfo.sgL_Myself')"
                              v-model="customerModel.sgL_Myself"></el-input>
                          </el-form-item>
                          <!-- <el-form-item label="自定義網址">
                          <el-input
                            placeholder="www.soonnet.org/<yourusename> (一旦儲存將無法更改)"
                            v-model="customerModel.sgL_Myself"
                          ></el-input>
                        </el-form-item> -->
                          <el-form-item label="Email">
                            <el-input disabled v-model="customerModel.sgL_LoginEmail"></el-input>
                          </el-form-item>
                          <el-form-item :label="$t('Customer.customerInfo.Sex')">
                            <el-radio v-model="customerModel.sgL_Sex" label="Male"> {{ $t('Customer.customerInfo.Male') }}
                            </el-radio>
                            <el-radio v-model="customerModel.sgL_Sex" label="Female"> {{
                              $t('Customer.customerInfo.Female') }}
                            </el-radio>
                          </el-form-item>
                          <el-form-item :label="$t('Customer.customerInfo.BirthF')">
                            <el-date-picker v-model="customerModel.sgL_BirthF" type="date"
                              :placeholder="$t('Customer.customerInfo.BirthF')">
                            </el-date-picker>
                          </el-form-item>
                          <el-form-item :label="$t('Customer.customerInfo.SelfNetworkDiskF')">
                            {{
                              customerModel.sgL_SelfNetworkDiskF
                            }}GB( {{ $t('Customer.customerInfo.Havebeenused') }})/{{
  customerModel.sgL_NetworkDiskCapacity
}}GB( {{ $t('Customer.customerInfo.gross') }})
                          </el-form-item>
                          <el-form-item :label="$t('Customer.customerInfo.information')">
                            <el-radio v-model="customerModel.sgL_IsRecepte" :label="true">
                              {{ $t('Customer.customerInfo.Soonnet') }}</el-radio>
                            <el-radio v-model="customerModel.sgL_IsRecepte" :label="false">
                              {{ $t('Customer.customerInfo.no') }}</el-radio>
                          </el-form-item>
                          <el-form-item>
                            <el-button type="primary" @click="updateCustomerInfo('customerModel')"> {{
                              $t('Customer.customerInfo.store') }}</el-button>
                          </el-form-item>
                        </el-form>
                      </div>
                    </div>
                    <div class="row" v-show="showType === 2">
                      <div class="col-12">
                        <el-form :model="Pwmodel" label-width="120px" ref="Pwmodel" :rules="PwmodelRule">
                          <el-form-item :label="$t('Customer.customerInfo.Currentpassword')" prop="pw">
                            <el-input v-model="Pwmodel.pw" show-password></el-input>
                          </el-form-item>
                          <el-form-item :label="$t('Customer.customerInfo.newpw')" prop="newpw">
                            <el-input v-model="Pwmodel.newpw" show-password></el-input>
                          </el-form-item>
                          <el-form-item :label="$t('Customer.customerInfo.repeatpw')" prop="repeatpw">
                            <el-input v-model="Pwmodel.repeatpw" show-password></el-input>
                          </el-form-item>
                          <el-form-item>
                            <el-button type="primary" @click="changepw('Pwmodel')"> {{
                              $t('Customer.customerInfo.changepw') }}
                            </el-button>
                          </el-form-item>
                        </el-form>
                      </div>
                    </div>
                    <div class="row" v-show="showType === 3">
                      <div class="col-12">
                        <div class="">
                          <div class="card-header">
                            <div class="row">
                              <div class="col-8">
                                <ul class="nav nav-pills" v-if="countList != null">
                                  <li class="nav-item">
                                    <a class="nav-link" :class="{ active: isreciver == true }" href="javascript:void(0);"
                                      @click="showContent('reciver')" data-toggle="tab"> {{
                                        $t('Customer.customerInfo.reciver') }}<span class="count">{{
    this.countList.notMsgCount
  }}</span></a>
                                  </li>
                                  <li class="nav-item">
                                    <a class="nav-link" :class="{ active: isreciver != true }" href="javascript:void(0);"
                                      @click="showContent('sent')" data-toggle="tab"> {{ $t('Customer.customerInfo.sent')
                                      }}<span class="count">{{
  this.countList.msgCount
}}</span></a>
                                  </li>
                                </ul>
                              </div>
                              <!-- Search bar -->
                              <div class="col-4">
                                <div class="search">
                                  <el-input :placeholder="$t('Customer.customerInfo.search')" suffix-icon="fas fa-search"
                                    v-model="title"></el-input>
                                </div>
                              </div>
                              <!-- /.Search bar -->
                            </div>
                          </div>
                          <!-- /.card-header -->
                          <div class="">
                            <!-- My Profile -->
                            <div class="my-comment section-group">
                              <div class="row">
                                <div class="col-12">
                                  <div class="card">
                                    <div class="card-body p-0">
                                      <el-table :data="reciverModel">
                                        <el-table-column width="500" :label="$t('Customer.customerInfo.msg')">
                                          <template slot-scope="scope">
                                            <a :href="scope.row.clickUrl">{{
                                              scope.row.sgL_Msg_MContent
                                            }}</a>
                                          </template>
                                        </el-table-column>
                                        <el-table-column prop="sgL_ImageLogin" width="38">
                                          <template slot-scope="scope">
                                            <avatarVue :src="scope.row.sgL_ImageLogin"></avatarVue>
                                            <!-- <el-avatar
                                  size="small"
                                  :src="scope.row.sgL_ImageLogin"
                                >
                                </el-avatar> -->
                                          </template>
                                        </el-table-column>
                                        <el-table-column prop="sgL_Mem_DisplayName"
                                          :label="$t('Customer.customerInfo.user')">
                                        </el-table-column>
                                        <el-table-column prop="sgL_Msg_MAddTimerI"
                                          :label="$t('Customer.customerInfo.date')" width="110"></el-table-column>
                                        <el-table-column :label="$t('Customer.customerInfo.Controls')" width="110">
                                          <template slot-scope="scoped">
                                            <a :href="scoped.row.clickUrl" :title="$t('Customer.customerInfo.check')"><i
                                                class="fa fa-eye fa-fw mx-2" aria-hidden="true"></i></a>
                                            <el-button icon="fa fa-trash-alt fa-fw mx-2" @click="deleteMsg(scoped.row.id)"
                                              type="danger" size="mini" v-show="type != 303"> {{
                                                $t('Customer.customerInfo.del') }}</el-button>
                                          </template>
                                        </el-table-column>
                                      </el-table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-12">
                                  <!--  引用分页组件 -->
                                  <pagination v-show="reciverModel && reciverModel.length > 0
                                    " :currentPage="pageParams.currentPage" :total="pageParams.total"
                                    :limit="pageParams.limit" :small="true" @handleCurrentChange="handleCurrentChange"
                                    @handleSizeChange="handleSizeChange" />
                                </div>
                              </div>
                            </div>
                            <!-- /.My Profile -->
                          </div>
                          <!-- /.card-body -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /.My Profile -->
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.nav-tabs-custom -->
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
    </section>
  </div>
</template>
<script>
import ImgCropperVue from "../common/ImgCropper.vue";
import avatarVue from "../common/avatar.vue";
import pagination from "../common/Page";


import medalView from "../Social/medalView.vue";
export default {
  components: {
    ImgCropperVue,
    avatarVue,
    pagination,
    medalView,
  },
  data () {
    return {
      showType: 1,
      userLogoBig: "",
      customer: null,
      customerModel: null,
        medalListData: [],
      Runningwater: {},
      Pwmodel: {
        pw: null,
        newpw: null,
        repeatpw: null,
      },
      isShow: true,
      PwmodelRule: {

      },
      customerModelrule: {

      },
      type: 303,
      reciverModel: null,
      isreciver: true,
      title: null,
      countList: null,
      pageParams: {
        currentPage: 1,
        limit: 12,
        total: 0,
        pageshow: false,
      },
    };
  },
  created () {
    this.$store.dispatch("updateCurrentIndex", 0);
    this.customer = this.$store.getters.getcustomer;
    //this.userLogoBig = this.customer.userLogoBig;
    this.getCustomerModel();
    this.setRule();
    this.GetEventMedalsByUser();
    this.SystemActivityFirst();
  },
  computed: {
    customers () {
      return this.$store.getters.getcustomer;
    },
  },
  watch: {
    type (newvalue, oldvalue) {
      if (newvalue != oldvalue) {
        this.handleCurrentChange(1);
        this.pageParams.limit = 12;
        this.pageParams.total = 0;
        this.getReciver();
      }
    },
    title (newvalue, oldvalue) {
      if (newvalue != oldvalue) {
        this.handleCurrentChange(1);
        this.getReciver();
      }
    },
    '$i18n.locale' () {
      this.setRule();
    },
  },
  methods: {
       async GetEventMedalsByUser () {
      // this.loginUser.userId
      const { data: { result } } = await this.$api.common.GetEventMedalsByUser({ 'usersId': this.loginUser.userId });
      this.medalListData = result;
    },
      async SystemActivityFirst () {
      const params = {};
      const { data: result } = await this.$api.medalApi.SystemActivityFirst(params);
      if (!result.success) {
        result.error.code !== 500 && this.$message.error(result.error.message);
        return;
      }
      this.Runningwater = result.result ? result.result : {};
    },
        async showExchangePoint (Id) {
      this.$refs.medalView.setData(Id);
    },
    setRule () {
      const that = this;
      this.PwmodelRule = {
        pw: [{ required: true, message: that.$t('Customer.customerInfo.PwmodelRule.pw'), trigger: "blur" }],
        newpw: [{ required: true, message: that.$t('Customer.customerInfo.PwmodelRule.newpw'), trigger: "blur" }],
        repeatpw: [
          { required: true, message: that.$t('Customer.customerInfo.PwmodelRule.repeatpw'), trigger: "blur" },
        ],
      };
      this.customerModelrule = {
        sgL_UsersName: [
          { required: true, message: that.$t('Customer.customerInfo.customerModelrule.sgL_UsersName'), trigger: "blur" },
        ],
        sgL_MyVideoName: [
          { required: true, message: that.$t('Customer.customerInfo.customerModelrule.sgL_MyVideoName'), trigger: "blur" },
        ],
        // sgL_Sex:[{required:true,message:'請輸入'}]
      };
    },
    getReciver () {
      let params = {
        Type: this.type,
        SGL_Msg_MContent: this.title,
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit, //从第几条开始查，
        MaxResultCount: this.pageParams.limit, //查多少条
      };
      this.$api.common.reciverMessage(params).then((res) => {
        if (res.data.success) {
          this.reciverModel = res.data.result.items;
          this.pageParams.total = res.data.result.totalCount;
          if (this.pageParams.total > 1) {
            this.pageParams.pageshow = true;
          }
        }
      });
    },
    getReciverMessagecountList () {
      let params = null;
      this.$api.common.getReciverMessagecountList(params).then((res) => {
        if (res.data.success) {
          this.countList = res.data.result;
        }
      });
    },
    deleteMsg (id) {
      let params = {
        Id: id,
      };
      this.$api.common.deleteMsg(params).then((res) => {
        if (res.data.success) {
          this.$message({
            type: "success",
            message: this.$t('message.operatesuccessfully'),
          });
          this.getReciverMessagecountList();
          if (this.isreciver == true) {
            this.type = 303;
          } else {
            this.type = 202;
          }
          this.getReciver();
        }
      });
    },
    handleCurrentChange (val) {
      this.pageParams.currentPage = val;
      this.getReciver();
    },
    handleSizeChange (val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.getReciver();
    },
    showContent (type) {
      if (type == "reciver") {
        this.isreciver = true;
        this.type = 303;
      } else {
        this.isreciver = false;
        this.type = 202;
      }
    },
    getCustomerModel () {
      let params = {
        Id: this.customer.Id,
      };
      this.$api.common.getCustomerModel(params).then((res) => {
        if (res.data.success) {
          this.customerModel = res.data.result;
        }
      });
    },
    changepw (formname) {
      this.$refs[formname].validate((valid) => {
        if (valid) {
          let params = {
            id: this.customer.id,
            thisPassword: this.Pwmodel.pw,
            password: this.Pwmodel.newpw,
          };
          this.$api.common.updatePw(params).then((res) => {
            if (res.data.success) {
              this.$message({
                type: "success",
                message: "修改成功",
              });
              //调用退出登录，跳转到登录页
              this.loginout();
            }
          });
        } else {
          this.$message({
            type: "error",
            message: "請檢查必填信息",
          });
        }
      });
    },
    loginout () {
      this.loginbtn = false;
      this.$store.commit("writecustomer", null);
      this.$store.commit("updatePermission", null);
      this.image = "https://api.soonnet.org/Userlogo_Smail.jpg";
      this.$router.push({ name: "customerLogin" });
      // this.getuser();
    },
    // getuser() {
    //   this.user = this.$store.getters.getcustomer;
    //   if (
    //     this.user != null &&
    //     this.user.userId != undefined &&
    //     this.user.userId != ""
    //   ) {
    //     this.image =
    //       "https://www.soonnet.org/Account/Acc_Resources/" +
    //       this.user.userId +
    //       "/Userlogo_Smail.jpg";
    //   }
    // },
    updateCustomerInfo (formname) {
      this.$refs[formname].validate((valid) => {
        if (valid) {
          let params = {
            id: this.customer.id,
            sgL_UsersName: this.customerModel.sgL_UsersName,
            sgL_MyVideoName: this.customerModel.sgL_MyVideoName,
            sgL_LoginEmail: this.customerModel.sgL_LoginEmail,
            sgL_Sex: this.customerModel.sgL_Sex,
            sgL_Birth: this.customerModel.sgL_BirthF,
            sgL_Myself: this.customerModel.sgL_Myself,
            sgL_IsRecepte: this.customerModel.sgL_IsRecepte,
          };
          this.$api.common.updateCustomerInfo(params).then((res) => {
            if (res.data.success) {
              this.$message({
                type: "success",
                message: "修改成功",
              });
              /*this.loginout();*/
              this.getCustomerModel();
            } else {
              this.$message.error(res.data.error.message);
            }
          });
        } else {
          this.$message({
            type: "error",
            message: "請檢查必填信息",
          });
        }
      });
    },
    change (type) {
      this.showType = type;
      if (type === 3) {
        this.getReciverMessagecountList();
        this.getReciver();
      }
    },
    changeUpload (file, fileList) {
      switch (file.raw.type) {
        case "image/jpeg":
          break;
        case "image/png":
          break;
        default:
          this.$message({
            message: "請選擇jpg/png格式",
          });
          this.$refs.avatarUploader.clearFiles();
          return;
      }
      /* const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error(`上傳文件大小不能超過 5MB!`);
        this.$refs.avatarUploader.clearFiles();
        return false;
      } */
      let test = new Image();
      test.src = window.URL.createObjectURL(file.raw);
      let width = 0;
      let height = 0;
      let that = this;
      test.onload = function () {
        width = test.width;
        height = test.height;
        if (width < 380 || height < 380) {
          that.$message({
            message: "請選擇尺寸大於380*380的圖片",
          });
          this.$refs.avatarUploader.clearFiles();
          return;
        }
        that.$refs.cro.initData(file);
        that.$refs.cro.setDialogVisible(true);
      };
    },
    cropperConfirm (img) {
      // let test = new Image();
      // test.src = window.URL.createObjectURL(img);
      // let width = 0;
      // let height = 0;
      // test.onload = function () {
      //   width = test.width;
      //   height = test.height;
      //   console.log(width, height);
      // };
      // return;

      let formData = new FormData();
      formData.append("file", img, "DX.jpg");
      this.$api.common.uploadUserImage(formData).then((res) => {
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.customer.userLogoBig =
            res.data.result.url + "?id=" + res.data.result.uploadId;
          this.customer.userLogoSmail =
            res.data.result.url + "?id=" + res.data.result.uploadId;
          this.$store.commit("writecustomer", this.customer);
          localStorage.setItem("userinfo", JSON.stringify(this.customer));
        } else {
          this.$message({ type: "error", message: res.data.error.message });
        }
      });
      this.$refs.cro.setDialogVisible(false);
      //this.userLogoBig = img;
      //this.$refs.cro.setDialogVisible(false);
    },
  },
};
</script>

<style scoped>
.avatar-uploader {
  width: 100px;
  height: 100px;
  background-color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/Customer/customerInfo.vue